import React from 'react';
import { Link } from 'react-router-dom';
import { Settings, Home, Users, Wrench, MapPin, Heart, Mail, LayoutTemplate, Menu, ChevronRight, HandHeart, Leaf, ShieldCheck } from 'lucide-react';

const sections = [
  { id: 'settings', label: 'Paramètres généraux', desc: 'Logo, nom du site, contact, réseaux sociaux', icon: Settings, color: 'from-slate-500 to-slate-700' },
  { id: 'navigation', label: 'Menu de navigation', desc: 'Éléments du menu principal et bouton CTA', icon: Menu, color: 'from-sky-500 to-sky-700' },
  { id: 'home', label: 'Page d\'accueil', desc: 'Hero, statistiques, avantages, étapes, témoignages…', icon: Home, color: 'from-emerald-500 to-teal-600' },
  { id: 'howItWorks', label: 'Comment ça marche', desc: 'Mode d\'emploi, fonctionnalités, caractéristiques', icon: Wrench, color: 'from-amber-500 to-orange-600' },
  { id: 'impact', label: 'Impact écologique', desc: 'Dangers, pétrole, transport, déchets, coût', icon: Leaf, color: 'from-emerald-500 to-lime-600' },
  { id: 'association', label: 'Initiative Citoyenne', desc: 'Histoire, valeurs, cercles de citoyens', icon: Users, color: 'from-purple-500 to-pink-600' },
  { id: 'support', label: 'Je soutiens', desc: 'Besoins, déploiement, réductions fiscales', icon: HandHeart, color: 'from-emerald-500 to-sky-500' },
  { id: 'locations', label: 'Kiosques (carte)', desc: 'Liste des kiosques avec statuts et coordonnées', icon: MapPin, color: 'from-rose-500 to-red-600' },
  { id: 'donate', label: 'Faire un don', desc: 'Paliers de don, garanties, FAQ', icon: Heart, color: 'from-pink-500 to-rose-600' },
  { id: 'contact', label: 'Contact', desc: 'Canaux de contact, infos pratiques', icon: Mail, color: 'from-cyan-500 to-blue-600' },
  { id: 'legal', label: 'Mentions légales & RGPD', desc: 'Mentions légales, politique de confidentialité, cookies', icon: ShieldCheck, color: 'from-slate-600 to-sky-800' },
  { id: 'footer', label: 'Pied de page', desc: 'Description, newsletter, copyright', icon: LayoutTemplate, color: 'from-indigo-500 to-purple-600' },
];

export default function AdminContentHub() {
  return (
    <div className="p-8 lg:p-10">
      <header className="mb-8">
        <h1 className="font-display font-extrabold text-3xl text-sky-950">Contenu du site</h1>
        <p className="text-slate-500 mt-1">Modifiez le texte, les images et les listes de chaque page.</p>
      </header>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {sections.map((s) => (
          <Link
            key={s.id}
            to={`/admin/content/${s.id}`}
            className="group p-6 rounded-2xl bg-white border border-sky-100 hover:shadow-md hover:-translate-y-0.5 transition-all"
          >
            <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${s.color} flex items-center justify-center mb-4 shadow-md`}>
              <s.icon className="w-6 h-6 text-white" />
            </div>
            <div className="flex items-start justify-between gap-2">
              <div>
                <h3 className="font-display font-bold text-sky-950">{s.label}</h3>
                <p className="text-xs text-slate-500 mt-1 leading-relaxed">{s.desc}</p>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-300 group-hover:text-sky-600 group-hover:translate-x-1 transition-all flex-shrink-0" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
